export default __webpack_public_path__ + "static/media/K_Kururu.4bfe9932.svg";